// extracted by css-extract-rspack-plugin
export default {"serviceFilterMenuButton":"R8o0XDiPxE8i6vL7"};